<template>
    <div>
        <h2 class="mt-xl text-md">{{ title }}</h2>

        <div class="overflow-x-auto mt-sm">
            <table class="table striped">
                <thead>
                    <tr>
                        <th class="w-1/5">Art.nr</th>
                        <th>Namn</th>
                        <th class="w-1/5">Pris (exkl. moms)</th>
                        <th>Pris (inkl. moms)</th>
                        <th>ROT/RUT</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(article, index) in articles">
                        <td>
                            <checkbox-input
                                v-model="article.is_checked"
                            >
                                {{ article.fortnox_article_id }}
                            </checkbox-input>
                        </td>
                        <td>{{ article.name }}</td>
                        <td>
                            <text-input
                                v-model="article.price"
                                name="price"
                                type="text"
                                :error="getArticleErrorMessage(index, 'price')"
                            />
                        </td>
                        <td>{{ article.is_checked ? article.price * 1.25 : '' }}</td>
                        <td>
                            <select-input
                                v-model="article.deduction"
                                name="deduction"
                                :options="houseworkTypes"
                                :opt-out-sorting="true"
                                class="mb-0"
                                style="min-width: 120px;"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <input-error
            :errors="errors"
            name="articles"
        />

        <div class="overflow-x-auto">
            <table class="table description-list not-striped">
                <tbody>
                    <tr>
                        <td>Totalt pris (exkl. moms)</td>
                        <td>{{ totalExact }} kr</td>
                    </tr>
                    <tr>
                        <td>Moms 25 %</td>
                        <td>{{ VATExact }} kr</td>
                    </tr>
                    <tr>
                        <td>Skattereduktion</td>
                        <td>-{{ taxReductionExact }} kr</td>
                    </tr>
                    <tr>
                        <td>Kund ska betala (inkl. moms)</td>
                        <td>{{ totalToPayExact }} kr</td>
                    </tr>
                    <tr v-if="isMonthly">
                        <td>
                            <span class="mr-sm">Per månad i</span>
                            <select-input
                                v-model.number="numMonths"
                                :options="financialPeriodLengths"
                                class="mb-0"
                                style="display: inline-block; min-width: 90px;"
                            />
                            <span class="ml-sm">månader (inkl. moms)</span>
                        </td>
                        <td>{{ monthlyPayExact }} kr</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            initialArticles: {
                type: Array,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            initialNumMonths: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                houseworkType: 'rot',
                action: 'dig',
                financialPeriodLengths: {
                    12: '12',
                    24: '24',
                    36: '36',
                },
                houseworkTypes: {
                    none: 'Ingen',
                    rot: 'ROT',
                    materialCost: 'Materialkostnad ROT',
                    rut: 'RUT',
                    materialCostRut: 'Materialkostnad RUT',
                },
                articles: this.initialArticles,
                errors: {},
                loading: false,
                numMonths: this.initialNumMonths,
            };
        },

        computed: {
            checkedArticles() {
                var articles = this.articles
                    .filter(article => article.is_checked)
                    .map(article => {
                        return {
                            fortnox_article_id: article.fortnox_article_id,
                            deduction: article.deduction,
                            price: article.price,
                            type: this.type,
                        };
                    });

                this.$emit('updateArticles', articles);

                return articles;
            },
            taxReduction() {
                return Math.round(this.taxReductionExact);
            },
            taxReductionExact() {
                const checkedArticles = this.checkedArticles;

                const checkedRotArticles = checkedArticles.filter(article => article.deduction === 'rot');
                const checkedRutArticles = checkedArticles.filter(article => article.deduction === 'rut');

                const rotArticleTotalPrice = checkedRotArticles.reduce((acc, article) => acc + Number(article.price), 0) * 1.25;
                const rutArticleTotalPrice = checkedRutArticles.reduce((acc, article) => acc + Number(article.price), 0) * 1.25;

                return rotArticleTotalPrice * .3 + rutArticleTotalPrice * .5;
            },
            total() {
                return Math.round(this.totalExact);
            },
            totalExact() {
                return this.checkedArticles.reduce((a, b) => +a + +b.price, 0);
            },
            VAT() {
                return Math.round(this.VATExact);
            },
            VATExact() {
                return this.totalExact * 0.25;
            },
            totalToPay() {
                return Math.round(this.totalToPayExact);
            },
            totalToPayExact() {
                return this.totalExact + this.VATExact - this.taxReductionExact;
            },
            isMonthly() {
                return this.type === 'monthly';
            },
            monthlyPay() {
                this.$emit('updateNumMonths', this.numMonths);

                return this.totalToPay / this.numMonths;
            },
            monthlyPayExact() {
                this.$emit('updateNumMonths', this.numMonths);

                return this.totalToPayExact / this.numMonths;
            },
        },

        methods: {
            getArticleErrorMessage(index, key) {
                if (this.errors && this.errors[`articles.${index}.${key}`]) {
                    return this.errors[`articles.${index}.${key}`][0];
                }
            },
        },
    };
</script>
